const fmt = require("indian-number-format");

export default function TotalCard({
  nse_cash,
  pl,
  deposit_wallet,
  withdraw_wallet,
  deposit,
  credit,
  withdraw,
}) {
  const userType = Number(localStorage.getItem("user_type") || 7);

  /** ------------------ CARD STYLE ------------------ **/
  const cardStyle = {
    minWidth: "120px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "var(--background)",
    border: "2px solid var(--hover)",
    color: "var(--text)",
    display: "flex",
    flexDirection: "column",
  };

  const labelStyle = {
    fontSize: "0.7rem",
    opacity: 0.7,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "1rem",
    fontWeight: 700,
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "10px 20px",
        background: "var(--background)",
        color: "var(--text)",
        borderBottom: "1px solid var(--hover)",
      }}
    >
      {deposit_wallet > 0 && (
        <div style={cardStyle}>
          <span style={labelStyle}>WALLET DEPOSIT</span>
          <span
            style={{
              ...valueStyle,
              color: "var(--buy)",
            }}
          >
            {fmt.format(parseFloat(deposit_wallet).toFixed(0))}
          </span>
        </div>
      )}

      <div style={cardStyle}>
        <span style={labelStyle}>DEPOSIT</span>
        <span
          style={{
            ...valueStyle,
            color: "var(--buy)",
          }}
        >
          {fmt.format(parseFloat(deposit).toFixed(0))}
        </span>
      </div>

      {/* TOTAL P/L */}
      <div style={cardStyle}>
        <span style={labelStyle}>ACCOUNT P&L</span>
        <span
          style={{
            ...valueStyle,
            color: pl >= 0 ? "var(--buy)" : "var(--sell)",
          }}
        >
          {fmt.format(parseFloat(pl).toFixed(0))}
        </span>
      </div>

      {withdraw_wallet > 0 && (
        <div style={cardStyle}>
          <span style={labelStyle}>WALLET DEPOSIT</span>
          <span
            style={{
              ...valueStyle,
              color: "var(--sell)",
            }}
          >
            {fmt.format(parseFloat(withdraw_wallet).toFixed(0))}
          </span>
        </div>
      )}

      <div style={cardStyle}>
        <span style={labelStyle}>WITHDRAW</span>
        <span
          style={{
            ...valueStyle,
            color: "var(--sell)",
          }}
        >
          {fmt.format(parseFloat(withdraw).toFixed(0))}
        </span>
      </div>

      {(nse_cash === 1 || credit > 0) && (
        <div style={cardStyle}>
          <span style={labelStyle}>CASH DEPOSIT</span>
          <span
            style={{
              ...valueStyle,
              color: "var(--sell)",
            }}
          >
            {fmt.format(parseFloat(credit).toFixed(0))}
          </span>
        </div>
      )}
    </div>
  );
}
